export const PLAYING = 'V-PLAYBACKS-PLAYBACKEVENT-PLAYING'
export const BUFFERING = 'V-PLAYBACKS-PLAYBACKEVENT-BUFFERING'
export const NOT_BUFFERING = 'V-PLAYBACKS-PLAYBACKEVENT-NOT_BUFFERING'
export const PAUSED = 'V-PLAYBACKS-PLAYBACKEVENT-PAUSED'
export const TIME_UPDATE = 'V-PLAYBACKS-PLAYBACKEVENT-TIME_UPDATE'
export const LOAD_METADATA = 'V-PLAYBACKS-PLAYBACKEVENT-LOAD_METADATA'
export const CAN_PLAY = 'V-PLAYBACKS-PLAYBACKEVENT-CAN_PLAY'
export const ENDED = 'V-PLAYBACKS-PLAYBACKEVENT-ENDED'
export const VOLUME_CHANGE = 'V-PLAYBACKS-PLAYBACKEVENT-VOLUME_CHANGE'
export const ERROR = 'V-PLAYBACKS-PLAYBACKEVENT-ERROR'
export const START_PROGRESS = 'V-PLAYBACKS-PLAYBACKEVENT-START_PROGRESS'
export const SEEK_CHANGE = 'V-PLAYBACKS-PLAYBACKEVENT-SEEK_CHANGE'
export const LOAD_START = 'V-PLAYBACKS-PLAYBACKEVENT-LOAD_START'
export const BROWSER_PAUSE = 'V-PLAYBACKS-PLAYBACKEVENT-BROWSER_PAUSE'

export default {
  PLAYING,
  BUFFERING,
  NOT_BUFFERING,
  PAUSED,
  TIME_UPDATE,
  LOAD_METADATA,
  CAN_PLAY,
  ENDED,
  ERROR,
  VOLUME_CHANGE,
  SEEK_CHANGE,
  START_PROGRESS,
  LOAD_START,
  BROWSER_PAUSE,
}
